import { render, staticRenderFns } from "./SurrogateDetailDialog.vue?vue&type=template&id=6111069a&scoped=true"
import script from "./SurrogateDetailDialog.vue?vue&type=script&lang=js"
export * from "./SurrogateDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6111069a",
  null
  
)

export default component.exports